const menuItems = [
    {
        name: "highways",
        icon: "highway-white",
        dropdown: true,
        urlKey: "highways",
        paramKey: "highways"
    },
    {
        name: "restAreas",
        icon: "gas_station",
        dropdown: true,
        search: true,
        urlKey: "rest-areas",
        paramKey: "categories"
    },
    {
        name: "objects",
        icon: "tunnel",
        dropdown: true,
        urlKey: "objects",
        paramKey: "types"
    },
    {
        name: "tollPlacesType",
        icon: "money",
        urlKey: "toll-places",
        dropdown: true,
        paramKey: "tollPlacesType"
    },
    {
        name: "cameras",
        icon: "camera",
        urlKey: "cameras",
        paramKey: "cameras"
    },

    {
        name: "toll_calculation",
        icon: "calculator",
        calculation: true,
        tooltip: true,
        urlKey: "calculate-tolls"
    }
];
export default menuItems;
